/* eslint new-cap:0 */

import marquee from 'vanilla-marquee';

(function () {
	const els = document.querySelectorAll(`.hub-section-featured h2`);
	if (els.length === 0) {
		return;
	}

	for (const el of els) {
		new marquee(el, {
			speed: 200,
			delayBeforeStart: 0,
		});
	}
})();
